import React, { FC, PropsWithChildren, useEffect, useMemo, useState } from 'react'
import { PartnerContext, Partners } from '@shared/lib/partner'

const PartnerProvider: FC<PropsWithChildren> = ({ children }) => {
  const [partner, setPartner] = useState<Partners>(Partners.DEFAULT)

  useEffect(() => {
    const { partner } = document.documentElement.dataset

    setPartner(partner as Partners)
  }, [])

  const memoizedProviderProps = useMemo(() => ({ partner }), [partner])

  return <PartnerContext.Provider value={memoizedProviderProps}>{children}</PartnerContext.Provider>
}

export default PartnerProvider
